import {Component, OnInit} from "@angular/core";

@Component({
    selector: 'app-changelog',
    templateUrl: './changelog.component.html',
})
export class ChangelogComponent implements OnInit{
    constructor(){}

    ngOnInit(){

    }
}


// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/projects/shared/changelog/changelog.component.ts